<template>
  <div class="text-center">
    <v-dialog v-model="errorDialog" persistent max-width="1000">
      <v-card>
        <v-card-title class="text-h5 red darken-4"> Hibás kontrollerek </v-card-title>

        <v-card-text>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Név</th>
                  <th>IP</th>
                  <th>Szériaszám</th>
                  <th>Idő</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="controller in unreachableControllers" :key="controller.id">
                  <td>{{ controller.elementId }}</td>
                  <td>{{ controller.name }}</td>
                  <td>{{ controller.ip }}</td>
                  <td>{{ controller.serialNumber }}</td>
                  <td>{{ controller.time }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="$emit('update:errorDialog', false)"> Rendben </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    errorDialog: {
      type: Boolean,
      required: true,
    },
    unreachableControllers: {
      type: Array,
      required: false,
    },
  },
};
</script>
